import { LeftGrid } from "./LeftGrid";
import { RightGrid } from "./RightGrid";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Logout from '../../utils/Logout';

export function OperatorPannel({user_id}) {
    return (
        <Box
            sx={{
                flexGrow: 1,
                minHeight: '100vh',
                height: '100vh',
                overflowY: 'auto',
                overflowX: 'hidden',
                bgcolor: 'background.default',
                color: 'text.primary'
            }}
        >
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        Operator Panel
                    </Typography>
                    <Box component="div" sx={{ mr: 6 }}>
                        <Logout color="secondary" />
                    </Box>
                </Toolbar>
            </AppBar>
                <Grid
                    container
                    sx={{
                        alignItems: 'stretch',
                        minHeight: 'calc(100vh - 64px)',
                        height: 'auto',
                        overflow: 'visible'
                    }}
                >
                    <Grid item xs={6} sx={{ minHeight: 'calc(100vh - 64px)', overflow: 'visible' }}  >
                        <LeftGrid user_id={user_id} />
                    </Grid>
                    <Grid
                        item
                        xs={6}
                        sx={{
                            minHeight: 'calc(100vh - 64px)',
                            overflow: 'visible',
                            borderLeft: (theme) => `1px solid ${theme.palette.divider}`,
                            borderTop: 'none',
                        }}
                    >
                        <RightGrid user_id={user_id} />
                    </Grid>
                </Grid>
        </Box>
    )
}
